import React from 'react'
import TicketList from '../../features/admin/ticket/TicketList'

const TicketListPage = () => {
    return (
        <TicketList />
    )
}

export default TicketListPage
